import React from 'react'

// Illustrations des pastilles, reprises du canvas « Test inspiration Waze » (W1, W2)

const INK = '#0B1033'

export const ArrivalIllustration = ({ size = 76 }) => (
	<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="26" y="8" width="30" height="48" rx="3" fill="#BFD0FF" />
		<path d="M26 8L41 13V61L26 56Z" fill="#FFFFFF" />
		<circle cx="37" cy="36" r="2.4" fill={INK} stroke="none" />
		<path d="M3 29H13V22L25 34L13 46V39H3Z" fill="#FFFFFF" />
	</svg>
)

export const DepartureIllustration = ({ size = 76 }) => (
	<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M16 22V15a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7" />
		<rect x="5" y="22" width="36" height="30" rx="5" fill="#FFFFFF" />
		<path d="M15 22V52M31 22V52" />
		<circle cx="13" cy="57" r="3" fill={INK} />
		<circle cx="33" cy="57" r="3" fill={INK} />
		<path d="M40 30H50V23L62 35L50 47V40H40Z" fill="#FFFFFF" />
	</svg>
)

export const TourIllustration = ({ size = 48 }) => (
	<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M6 16L22 10L38 16L54 10V48L38 54L22 48L6 54Z" fill="#FFFFFF" />
		<path d="M22 10V48M38 16V54" />
		<path d="M12 44C18 38 24 44 30 36" strokeDasharray="3 5" />
		<path d="M44 36V16" />
		<path d="M44 16H57L53 21L57 26H44" fill={INK} />
	</svg>
)

export const FreeIcon = ({ size = 26 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M3.5 11L12 4.5L20.5 11" />
		<path d="M6 9.5V20H18V9.5" />
		<path d="M9 14.6L11.2 16.8L15.4 12.6" />
	</svg>
)

export const TourIcon = () => (
	<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M3 6.5L9 4L15 6.5L21 4V17.5L15 20L9 17.5L3 20Z" />
		<path d="M9 4V17.5M15 6.5V20" />
	</svg>
)

export const ChevronRight = ({ color = '#3D4660', strokeWidth = 2.6 }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M9 5l7 7-7 7" />
	</svg>
)

export const DotsIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" aria-hidden="true">
		<path d="M5 12h.01M12 12h.01M19 12h.01" />
	</svg>
)

export const ChevronLeft = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M15 5l-7 7 7 7" />
	</svg>
)

export const SearchIcon = ({ size = 26, color = INK }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.8" strokeLinecap="round" aria-hidden="true" style={{ flex: 'none' }}>
		<circle cx="11" cy="11" r="6.5" />
		<path d="M16 16l5 5" />
	</svg>
)

export const NoResultIcon = () => (
	<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3D4660" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none', marginTop: 1 }}>
		<circle cx="11" cy="11" r="6.5" />
		<path d="M16 16l5 5" />
		<path d="M8.5 8.5l5 5" />
	</svg>
)

export const CrossIcon = ({ size = 46, color = '#FFFFFF' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.8" strokeLinecap="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M6 6l12 12M18 6L6 18" />
	</svg>
)

export const ClearIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true">
		<path d="M6 6l12 12M18 6L6 18" />
	</svg>
)

export const SuitcaseIcon = ({ size = 26 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
		<rect x="3" y="7" width="18" height="13" rx="2.5" />
		<path d="M8 7v13M16 7v13" />
	</svg>
)

export const RecentIcon = () => (
	<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3D4660" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M3 12a9 9 0 1 0 3-6.7" />
		<path d="M3 4v4h4" />
		<path d="M12 7v5l3 2" />
	</svg>
)

export const CheckIcon = ({ size = 24, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M4 12.5l5 5L20 6.5" />
	</svg>
)

export const LockIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<rect x="5" y="11" width="14" height="10" rx="2" />
		<path d="M8 11V8a4 4 0 0 1 8 0v3" />
	</svg>
)

// Pastilles d'emplacement (canvas W5) : propriétaire, locatif, séjour, emplacement nu
export const OwnerPitchIllustration = () => (
	<svg width="34" height="34" viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M6 30L28 12L50 30" />
		<path d="M11 26V52H45V26" fill="#FFFFFF" />
		<rect x="21" y="36" width="12" height="16" fill="#BFD0FF" />
		<circle cx="51" cy="42" r="6" fill="#FFFFFF" />
		<path d="M51 48V60M51 55H56" />
	</svg>
)

export const RentalPitchIllustration = () => (
	<svg width="36" height="36" viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="4" y="18" width="56" height="30" rx="4" fill="#FFFFFF" />
		<rect x="10" y="25" width="12" height="9" rx="1.5" fill="#BFD0FF" />
		<rect x="28" y="25" width="10" height="23" fill="#FFFFFF" />
		<rect x="44" y="25" width="10" height="9" rx="1.5" fill="#BFD0FF" />
		<circle cx="16" cy="54" r="4" fill={INK} />
		<circle cx="48" cy="54" r="4" fill={INK} />
	</svg>
)

export const StayIllustration = () => (
	<svg width="34" height="34" viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M24 18V12a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6" />
		<rect x="8" y="18" width="48" height="36" rx="6" fill="#FFFFFF" />
		<rect x="20" y="18" width="24" height="36" fill="#BFD0FF" />
		<path d="M20 18V54M44 18V54" />
	</svg>
)

export const PlainPitchIllustration = () => (
	<svg width="34" height="34" viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M32 58C32 58 14 40 14 26a18 18 0 0 1 36 0c0 14-18 32-18 32Z" fill="#FFFFFF" />
		<circle cx="32" cy="26" r="7" fill="#BFD0FF" />
	</svg>
)

// Compteur et marques d'état d'un objet (canvas W8)
export const MinusIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" aria-hidden="true">
		<path d="M5 12h14" />
	</svg>
)

export const PlusIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" aria-hidden="true">
		<path d="M12 5v14M5 12h14" />
	</svg>
)

export const GapMark = ({ size = 26 }) => (
	<span aria-hidden="true" style={{ width: size, height: size, borderRadius: 999, background: '#B91C1C', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>
		<svg width={Math.round(size * 0.62)} height={Math.round(size * 0.62)} viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="3.4" strokeLinecap="round">
			<path d="M12 5v9" />
			<path d="M12 19h.01" />
		</svg>
	</span>
)

export const InfoIcon = ({ size = 20 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<circle cx="12" cy="12" r="9" />
		<path d="M12 11v6" />
		<path d="M12 7.5h.01" />
	</svg>
)

export const WarningIcon = ({ size = 22 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M12 3l10 18H2z" />
		<path d="M12 10v5" />
		<path d="M12 18h.01" />
	</svg>
)

export const CircleIcon = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true" style={{ flex: 'none' }}>
		<circle cx="12" cy="12" r="8" />
	</svg>
)

export const CameraIcon = ({ size = 26, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M4 8h3l2-3h6l2 3h3v11H4z" />
		<circle cx="12" cy="13" r="3.5" />
	</svg>
)

export const GalleryIcon = ({ size = 26, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<rect x="3" y="5" width="18" height="14" rx="2" />
		<circle cx="9" cy="10" r="1.6" />
		<path d="M21 16l-5-5-8 8" />
	</svg>
)

export const NoteIcon = ({ size = 28, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M4 5h16v11H10l-6 4z" />
	</svg>
)

export const PencilIcon = ({ size = 24 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M16.5 3.5l4 4L8 20H4v-4z" />
		<path d="M14 6l4 4" />
	</svg>
)

export const TrashIcon = ({ size = 24 }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M4 7h16" />
		<path d="M9 7V4h6v3" />
		<path d="M6 7l1 13h10l1-13" />
		<path d="M10 11v6M14 11v6" />
	</svg>
)

// Mon activité (canvas A1, A5)
export const HistoryIcon = ({ size = 24, color = 'currentColor' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M3.5 12a8.5 8.5 0 1 0 2.5-6" />
		<path d="M3 4v4h4" />
		<path d="M12 8v4.5l3 2" />
	</svg>
)

// Tuiles de l'écran Suite à donner (canvas W16)
export const CommentIcon = ({ size = 46, color = '#FFFFFF' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M4 5h16v11H9l-5 4z" />
		<path d="M8 9h8M8 12.5h5" />
	</svg>
)

export const WrenchIcon = ({ size = 46, color = '#FFFFFF' }) => (
	<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={color} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M44 6A14 14 0 0 0 30 24L8 46A6 6 0 0 0 18 56L40 34A14 14 0 0 0 58 20L50 24L44 18L48 10Z" />
	</svg>
)

// Point d'exclamation du bandeau Contesté (canvas W10)
// Fiche d'inventaire cochée : tuile « Faire l'inventaire » du tour (canvas M6b)
export const InventoryIcon = ({ size = 46, color = '#000095' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="5" y="4" width="14" height="17" rx="2" />
		<path d="M9 4h6v3H9z" />
		<path d="M8.5 12.5l2 2 4-4" />
		<path d="M9 18h6" />
	</svg>
)

export const AlertIcon = ({ size = 28, color = '#FFFFFF' }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" aria-hidden="true" style={{ flex: 'none' }}>
		<path d="M12 5v9" />
		<path d="M12 19h.01" />
	</svg>
)

// Illustrations de thèmes (canvas W7). Les thèmes sont personnalisés par chaque camping :
// on reconnaît les plus courants par mot-clé, sinon une icône générique (charte apps terrain).
const THEME_PATHS = {
	outdoor: (
		<React.Fragment>
			<path d="M6 24Q32 2 58 24Z" fill="#FFFFFF" />
			<path d="M19 24Q32 8 45 24" fill="none" />
			<path d="M32 8V56" />
			<rect x="12" y="38" width="40" height="6" rx="2" fill="#BFD0FF" />
			<path d="M17 44V58M47 44V58" />
		</React.Fragment>
	),
	bedroom: (
		<React.Fragment>
			<path d="M8 14V54" />
			<rect x="8" y="34" width="50" height="12" rx="3" fill="#FFFFFF" />
			<rect x="14" y="25" width="16" height="9" rx="3" fill="#BFD0FF" />
			<path d="M30 34Q44 26 58 34" fill="#FFFFFF" />
			<path d="M56 46V54" />
		</React.Fragment>
	),
	appliances: (
		<React.Fragment>
			<rect x="5" y="14" width="54" height="36" rx="5" fill="#FFFFFF" />
			<rect x="11" y="20" width="30" height="24" rx="3" fill="#BFD0FF" />
			<path d="M47 14V50" />
			<circle cx="53" cy="24" r="2" fill="#0B1033" />
			<circle cx="53" cy="32" r="2" fill="#0B1033" />
			<path d="M51 41H55" />
			<path d="M12 50V55M52 50V55" />
		</React.Fragment>
	),
	cleaning: (
		<React.Fragment>
			<path d="M6 30L10 58H32L36 30Z" fill="#FFFFFF" />
			<path d="M6 30Q21 14 36 30" fill="none" />
			<path d="M58 4L46 40" />
			<path d="M38 38L52 43L48 60L32 55Z" fill="#BFD0FF" />
			<path d="M38 46L35 56M44 48L41 58" />
		</React.Fragment>
	),
	kitchen: (
		<React.Fragment>
			<path d="M3 30H39" />
			<rect x="6" y="30" width="30" height="22" rx="4" fill="#FFFFFF" />
			<path d="M17 30V26H25V30" />
			<path d="M36 37H42" />
			<path d="M50 8V56" />
			<path d="M46 8V18Q46 22 50 22Q54 22 54 18V8" />
			<path d="M59 8Q64 18 59 30V56" fill="#BFD0FF" />
		</React.Fragment>
	),
	generic: (
		<React.Fragment>
			<path d="M8 20L32 8L56 20V46L32 58L8 46Z" fill="#FFFFFF" />
			<path d="M8 20L32 32L56 20" />
			<path d="M32 32V58" />
			<path d="M20 14L44 26V36" fill="none" />
		</React.Fragment>
	)
}

export function themeKind(name)
{
	const text = (name || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
	if (/cuisine|vaisselle|couvert/.test(text))
		return 'kitchen'
	if (/chambre|literie|linge|lit\b/.test(text))
		return 'bedroom'
	if (/exterieur|jardin|terrasse|barbecue/.test(text))
		return 'outdoor'
	if (/entretien|menage|nettoyage/.test(text))
		return 'cleaning'
	if (/electromenager|interieur|salon|sejour|television/.test(text))
		return 'appliances'
	return 'generic'
}

export const ThemeIllustration = ({ name, size = 44 }) => (
	<svg width={size} height={size} viewBox="0 0 64 64" fill="none" stroke={INK} strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		{THEME_PATHS[themeKind(name)]}
	</svg>
)
